import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {handleDefaultValues} from "../common/Utils";
import {useForm} from 'react-hook-form';
import MDButton from "../../components/MDButton";
import MDInput from "../../components/MDInput";
import {Chip, IconButton, InputAdornment, NativeSelect} from "@mui/material";
import {
  getInventoryByCategory,
  getInventoryEventPackages,
  getInventoryTypes,
  getInventoryWaivers
} from "../common/api/InventoryApi";
import Avatar from "@mui/material/Avatar";
import Icon from "@mui/material/Icon";
import Switch from "@mui/material/Switch";
import {HexColorPicker} from "react-colorful";
import Divider from "@mui/material/Divider";
import Checkbox from "@mui/material/Checkbox";
import {getCompanyForms} from "../common/api/WebApi";

export default function ManageInventoryEventTypeModal(props) {

  const rotate = {
    'transform': 'rotate(270deg)'
  };
  const [context, setContext] = useContext(AppContext);
  const [inventoryEventType, setInventoryEventType] = useState(props.inventoryEventType);

  const [initialDeposit, setInitialDeposit] = useState(!!props.inventoryEventType?.initialDeposit);
  const [initialDepositFee, setInitialDepositFee] = useState(!!props.inventoryEventType?.initialDepositFee);

  const [assignedEventPackages, setAssignedEventPackages] = useState([]);

  const [formInvalid, setFormInvalid] = useState(false);
  const [inventories, setInventories] = useState();
  const [waivers, setWaivers] = useState();
  const [forms, setForms] = useState();

  const [expandBackgroundColor, setExpandBackgroundColor] = useState(false);
  const [expandFontColor, setExpandFontColor] = useState(false);

  const [expandInventoryOptions, setExpandInventoryOptions] = useState(true);
  const [inventoryCategories, setInventoryCategories] = useState();
  const [eventPackages, setEventPackages] = useState([]);

  const [inventoryCategory, setInventoryCategory] = useState();
  const [inventoryWaiver, setInventoryWaiver] = useState(-1);

  useEffect(() => {
    getCompanyForms().then((resp) => {
      setForms(resp);
    });
    getInventoryWaivers().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setWaivers(result);
      }
    });
    loadEventPackages();
  }, [])

  useEffect(() => {
    let _t = {...props?.inventoryEventType};
    if (!_t.waiverGk) {
      _t.waiverGk = -1;
    }
    setInventoryEventType(_t);
  }, [props?.inventoryEventType]);

  useEffect(() => {
    if (!inventoryCategory || parseInt(inventoryCategory, 10) === -1) {
      setInventories([]);
      return;
    }
    loadInventoryByCategory(inventoryCategory);
  }, [inventoryCategory]);

  const [isNew, setIsNew] = useState(!!!props.inventoryEventType?.guid);

  const loadInventoryFn = async () => {
    getInventoryTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setInventoryCategories(result);
      }
    });
  }

  useEffect(() => {
    loadInventoryFn();
  }, []);

  const loadInventoryByCategory = async (category) => {
    getInventoryByCategory(category).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setInventories(result);
      }
    });
  }

  let defaults = handleDefaultValues(inventoryEventType);
  if (!inventoryEventType?.restrictedBookingType) {
    if (!defaults) {
      defaults = {};
    }
    defaults.restrictedBookingType = -1;
  }

  const {register, handleSubmit, setValue, control} = useForm({
    values: defaults
  });

  const handleClose = () => {
    props.handleClose();
  };

  const handleSave = (data) => {
    let _d = {...data};
    _d.fontColor = fontColor;
    _d.backgroundColor = backgroundColor;
    _d.infantOptionsEnabled = infantOptionsEnabled;
    _d.siblingOptionsEnabled = siblingOptionsEnabled;
    _d.eventPackageGroups = assignedEventPackages;
    _d.ongoingBooking = ongoingBooking;
    _d.restrictedBooking = restrictedBooking;

    props.handleSave(_d);
  };

  const assignInventory = (inventory) => {
    let _c = {...inventoryEventType};
    let _group = {
      inventory: inventory,
    }

    for (var j in _c.eventInventoryGroups) {
      if (_c.eventInventoryGroups[j].inventory.id == inventory.id) {
        return;
      }
    }
    if (!_c.eventInventoryGroups) {
      _c.eventInventoryGroups = [];
    }

    _c.eventInventoryGroups.push(_group);

    setInventoryEventType(_c);
  }

  const handleRemoveItem = (item) => {
    let _c = {...inventoryEventType};
    let idx;
    for (let j in _c.eventInventoryGroups) {
      if (_c.eventInventoryGroups[j].inventory.id == item.inventory.id) {
        idx = j;
        break;
      }
    }

    _c.eventInventoryGroups.splice(idx, 1);
    setInventoryEventType(_c);
  }

  const toggleDeposit = (e) => {
    setInitialDeposit(e.target.checked);
    let _inventoryEventType = {...inventoryEventType};
    _inventoryEventType.initialDeposit = e.target.checked;
    if (!e.target.checked) {
      _inventoryEventType.depositPercent = '';
    } else {
      setInitialDepositFee(false);
      _inventoryEventType.initialDepositFee = false;
      _inventoryEventType.depositFee = '';
    }
    setInventoryEventType(_inventoryEventType);
  }

  const toggleDepositFee = (e) => {
    setInitialDepositFee(e.target.checked);
    let _inventoryEventType = {...inventoryEventType};
    _inventoryEventType.initialDepositFee = e.target.checked;
    if (!e.target.checked) {
      _inventoryEventType.depositFee = '';
    } else {
      setInitialDeposit(false);
      _inventoryEventType.initialDeposit = false;
      _inventoryEventType.depositPercent = '';
    }
    setInventoryEventType(_inventoryEventType);
  }

  const [specialEvent, setSpecialEvent] = useState(false);
  const [privateAccess, setPrivateAccess] = useState(false);
  const [selfCancelDisabled, setSelfCancelDisabled] = useState(false);
  const [hideEndTime, setHideEndTime] = useState(false);
  const [memberOnly, setMemberOnly] = useState(false);
  const [hideAttendees, setHideAttendees] = useState(false);
  const [disableWaitlist, setDisableWaitlist] = useState(false);
  const [requireAttendees, setRequireAttendees] = useState(false);
  const [eventTypeInformational, setEventTypeInformational] = useState(false);

  const [backgroundColor, setBackgroundColor] = useState(props.inventoryEventType?.backgroundColor || "#0d6efd");
  const [fontColor, setFontColor] = useState(props.inventoryEventType?.fontColor || "#fff");

  useEffect(() => {
    if (props.inventoryEventType?.specialEvent) {
      setSpecialEvent(props.inventoryEventType?.specialEvent);
    }
    if (props.inventoryEventType?.selfCancelDisabled) {
      setSelfCancelDisabled(props.inventoryEventType?.selfCancelDisabled);
    }
    if (props.inventoryEventType?.hideEndTime) {
      setHideEndTime(props.inventoryEventType?.hideEndTime);
    }
    if (props.inventoryEventType?.privateAccess) {
      setPrivateAccess(props.inventoryEventType?.privateAccess);
    }
    if (props.inventoryEventType?.hideAttendees) {
      setHideAttendees(props.inventoryEventType?.hideAttendees);
    }
    if (props.inventoryEventType?.memberOnly) {
      setMemberOnly(props.inventoryEventType?.memberOnly);
    }
    if (props.inventoryEventType?.disableWaitlist) {
      setDisableWaitlist(props.inventoryEventType?.disableWaitlist);
    }
    if (props.inventoryEventType?.requireAttendees) {
      setRequireAttendees(props.inventoryEventType?.requireAttendees);
    }
    if (props.inventoryEventType?.eventTypeInformational) {
      setEventTypeInformational(props.inventoryEventType?.eventTypeInformational);
    }
  }, [props?.inventoryEventType]);

  const toggleSpecialEvent = (e) => {
    setSpecialEvent(e.target.checked);
    let _inventoryEventType = {...inventoryEventType};
    _inventoryEventType.specialEvent = e.target.checked;
    setInventoryEventType(_inventoryEventType);
  }

  const togglePrivateAccess = (e) => {
    setPrivateAccess(e.target.checked);
    let _inventoryEventType = {...inventoryEventType};
    _inventoryEventType.privateAccess = e.target.checked;
    setInventoryEventType(_inventoryEventType);
  }

  const toggleSelfCancel = (e) => {
    setSelfCancelDisabled(e.target.checked);
    let _inventoryEventType = {...inventoryEventType};
    _inventoryEventType.selfCancelDisabled = e.target.checked;
    setInventoryEventType(_inventoryEventType);
  }

  const [siblingDiscount, setSiblingDiscount] = useState(false); //props.inventoryEventType?.siblingDiscount

  const [siblingOptionsEnabled, setSiblingOptionsEnabled] = useState(false); // !!!props.inventoryEventType?.siblingOptionsEnabled)
  const [infantOptionsEnabled, setInfantOptionsEnabled] = useState(false); // !!!props.inventoryEventType?.siblingOptionsEnabled)
  const [familyPass, setFamilyPass] = useState(false); // !!!props.inventoryEventType?.familyPass
  const [ongoingBooking, setOngoingBooking] = useState(false);
  const [restrictedBooking, setRestrictedBooking] = useState(false);

  const loadEventPackages = () => {
    getInventoryEventPackages().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setEventPackages(result);
        const eventGroups = inventoryEventType?.eventPackageGroups ? [...inventoryEventType?.eventPackageGroups] : [];
        let assignedGroups = [];
        const packages = [...result];
        for (let j in eventGroups) {
          for (let k in packages) {
            if (eventGroups[j].eventPackageId === packages[k].id) {
              assignedGroups.push(packages[k]);
            }
          }
        }
        setAssignedEventPackages(assignedGroups);
      }
    });
  }

  useEffect(() => {
    if (props.inventoryEventType?.familyPass) {
      setFamilyPass(props.inventoryEventType?.familyPass);
    }
    if (props.inventoryEventType?.siblingDiscount) {
      setSiblingDiscount(props.inventoryEventType?.siblingDiscount);
    }
    if (props.inventoryEventType?.siblingOptionsEnabled) {
      setSiblingOptionsEnabled(props.inventoryEventType?.siblingOptionsEnabled);
    }
    if (props.inventoryEventType?.infantOptionsEnabled) {
      setInfantOptionsEnabled(props.inventoryEventType?.infantOptionsEnabled);
    }
    if (props.inventoryEventType?.ongoingBooking) {
      setOngoingBooking(props.inventoryEventType?.ongoingBooking);
    }
    if (props.inventoryEventType?.restrictedBooking) {
      setRestrictedBooking(props.inventoryEventType?.restrictedBooking);
    }
  }, [props?.inventoryEventType]);

  const toggleMemberOnly = (e) => {
    setMemberOnly(e.target.checked);
    let _inventoryEventType = {...inventoryEventType};
    _inventoryEventType.memberOnly = e.target.checked;
    if (e.target.checked) {
      setInitialDeposit(false);
      _inventoryEventType.initialDeposit = false;
    }

    setInventoryEventType(_inventoryEventType);
  }

  const toggleHideAttendees = (e) => {
    setHideAttendees(e.target.checked);
    let _inventoryEventType = {...inventoryEventType};
    _inventoryEventType.hideAttendees = e.target.checked;

    setInventoryEventType(_inventoryEventType);
  }

  const toggleHideEndTime = (e) => {
    setHideEndTime(e.target.checked);
    let _inventoryEventType = {...inventoryEventType};
    _inventoryEventType.hideEndTime = e.target.checked;
    setInventoryEventType(_inventoryEventType);
  }

  const toggleDisableWaitlist = (e) => {
    setDisableWaitlist(e.target.checked);
    let _inventoryEventType = {...inventoryEventType};
    _inventoryEventType.disableWaitlist = e.target.checked;

    setInventoryEventType(_inventoryEventType);
  }

  const handleSiblingOptionsToggle = (e) => {
    setSiblingOptionsEnabled(e.target.checked);
    if (!e.target.checked) {
      setSiblingDiscount(null);
    }
  }

  const handleInfantOptionsToggle = (e) => {
    setInfantOptionsEnabled(e.target.checked);
    if (!e.target.checked) {
      setSiblingDiscount(null);
    }
  }
  const toggleRequireAttendees = (e) => {
    setRequireAttendees(e.target.checked);
    let _inventoryEventType = {...inventoryEventType};
    _inventoryEventType.requireAttendees = e.target.checked;
    setInventoryEventType(_inventoryEventType);
  }

  const toggleEventTypeInformational = (e) => {
    setEventTypeInformational(e.target.checked);
    let _inventoryEventType = {...inventoryEventType};
    _inventoryEventType.eventTypeInformational = e.target.checked;
    setInventoryEventType(_inventoryEventType);
  }

  const toggleOngoingBooking = (e) => {
    let isChecked = e.target.checked;
    setOngoingBooking(e.target.checked);
    if (isChecked) {
      setRestrictedBooking(false);
      setValue('restrictedBooking', false);
    }
  }

  const toggleRestrictedBooking = (e) => {
    let isChecked = e.target.checked;
    setRestrictedBooking(e.target.checked);
    if (isChecked) {
      setOngoingBooking(false);
      setValue('ongoingBooking', false);
    }
  }

  // MINUTE(1, "Minute"),
  //   HOUR(2, "Hour"),
  //   DAY(3, "Day")

  const timeUnitTypes = [
    {
      id: 1,
      name: 'Minutes'
    },
    {
      id: 2,
      name: 'Hours'
    },
    {
      id: 3,
      name: 'Days'
    }
  ]

  const toggleEventPackage = (eventPackage, checked) => {

    let _inventory = {...inventoryEventType};
    let _assignedEventPackages = [...assignedEventPackages];
    let inList = false;
    for (let j in _assignedEventPackages) {
      if (eventPackage.id === _assignedEventPackages[j].id) {
        inList = true;
      }
    }

    if (checked && !inList) {
      _assignedEventPackages.push(eventPackage);
    }

    if (!checked && inList) {
      let idx;
      for (let j in _assignedEventPackages) {
        if (_assignedEventPackages[j].id === eventPackage.id) {
          idx = j;
        }
      }
      _assignedEventPackages.splice(idx, 1);
    }

    setAssignedEventPackages([..._assignedEventPackages]);
  }

  const assignedEventPackage = (eventPackage) => {
    let _assignedEventPackages = [...assignedEventPackages];
    let cond = false;
    for (let j in _assignedEventPackages) {
      if (eventPackage.id === _assignedEventPackages[j].id) {
        cond = true;
      }
    }
    return cond;
  }

  return (
    <Modal onHide={handleClose} size={'lg'} show={props.show}>
      <form onSubmit={handleSubmit(handleSave)} id={'inventoryTypeForm'}>
        <Modal.Header closeButton>
          <Modal.Title>{isNew ? 'Create New' : 'Manage'} Event Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>

            <Col className={'col col-main'} xs={12}>
              <Container>
                <Row className={'mb-2'}>
                  <Col className={'col'} sm={12} xs={12}>
                    <h5>General Information</h5>
                  </Col>
                </Row>
                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">
                      <MDInput type="text" required
                               {...register('name', {
                                 maxLength: 155
                               })}
                               autoComplete="off"
                               className="form-control" id="name"
                               InputLabelProps={{shrink: true}}
                               label={"Event Type Name"}
                               placeholder={"Enter Event Type Name"}/>
                    </div>
                  </Col>
                </Row>
                <Row className={'mt-3'}>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">
                      <MDInput type="text"
                               InputLabelProps={{shrink: true}}
                               label={"Event Type Description"}
                               {...register('desc')}
                               autoComplete="off"
                               maxLength={255}
                               className="form-control" id="desc"
                               placeholder="Event Type Description"/>
                    </div>
                  </Col>
                </Row>

                <Row className={'mt-2'}>
                  <Col className={'col'} sm={4} xs={12}>
                    <div className="form-group">
                      <label htmlFor="inventoryWaiver">Calendar Background Color</label>
                      <MDInput type="text" required
                               InputProps={{
                                 startAdornment: <>
                                   <div
                                     onClick={() => {
                                       setExpandBackgroundColor(!expandBackgroundColor)
                                     }}
                                     style={{
                                       margin: '-5px',
                                       borderRadius: '4px',
                                       boxShadow: '0 0 2px #ccc',
                                       cursor: 'pointer',
                                       width: '35px',
                                       height: '25px',
                                       background: backgroundColor
                                     }}></div>
                                 </>
                               }}
                               {...register('backgroundColor')}
                               onChange={(e) => {
                                 setBackgroundColor(e.target.value)
                               }}
                               value={backgroundColor}/>
                      {expandBackgroundColor &&
                        <div style={{
                          paddingRight: '20px',
                          marginRight: '-20px'
                        }}>
                          <MDButton
                            style={{
                              float: 'right',
                              margin: '-10px',
                              zIndex: '3',
                              position: 'relative',
                              background: '#fff'
                            }}
                            onClick={() => {
                              setExpandBackgroundColor(false)
                            }}
                            variant="outlined"
                            color="secondary"
                            size="small"
                            circular
                            iconOnly
                          >
                            <Icon>close</Icon>
                          </MDButton>

                          <HexColorPicker
                            style={{
                              width: 'auto'
                            }}
                            color={backgroundColor} onChange={(color) => {
                            setBackgroundColor(color);
                          }}/>
                        </div>
                      }
                    </div>
                  </Col>

                  <Col className={'col'} sm={4} xs={12}>
                    <div className="form-group">
                      <label htmlFor="inventoryWaiver">Calendar Font Color</label>
                      <MDInput type="text" required
                               InputProps={{
                                 startAdornment: <>
                                   <div
                                     onClick={() => {
                                       setExpandFontColor(!expandFontColor)
                                     }}
                                     style={{
                                       margin: '-5px',
                                       borderRadius: '4px',
                                       boxShadow: '0 0 2px #ccc',
                                       cursor: 'pointer',
                                       width: '35px',
                                       height: '25px',
                                       background: fontColor
                                     }}></div>
                                 </>
                               }}
                               {...register('fontColor')}
                               onChange={(e) => {
                                 setFontColor(e.target.value)
                               }}
                               value={fontColor}/>
                      {expandFontColor &&
                        <div style={{
                          paddingRight: '20px',
                          marginRight: '-20px'
                        }}>
                          <MDButton
                            style={{
                              float: 'right',
                              margin: '-10px',
                              zIndex: '3',
                              position: 'relative',
                              background: '#fff'
                            }}
                            onClick={() => {
                              setExpandFontColor(false)
                            }}
                            variant="outlined"
                            color="secondary"
                            size="small"
                            circular
                            iconOnly
                          >
                            <Icon>close</Icon>
                          </MDButton>

                          <HexColorPicker
                            style={{
                              width: 'auto'
                            }}
                            color={fontColor} onChange={(color) => {
                            setFontColor(color);
                          }}/>
                        </div>
                      }
                    </div>
                  </Col>
                  <Col className={'col'} sm={4} xs={12}>
                    <label>Example</label>
                    <div style={{
                      borderRadius: '12px',
                      padding: '10px 20px 10px 25px',
                      background: backgroundColor
                    }}>
                      <p style={{
                        color: fontColor
                      }}>This is Example Text</p>

                    </div>
                  </Col>

                </Row>

                <Divider/>

                <Row className={'mt-4'}>
                  <Col className={'col'} sm={12} xs={12}>
                    <h5>Notifications</h5>
                  </Col>
                </Row>

                <Row>
                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">
                      <MDInput type="text"
                               InputLabelProps={{shrink: true}}
                               label={"Event Booking Notification"}
                               {...register('eventBookNotifyEmail')}
                               name={'eventBookNotifyEmail'}
                               autoComplete="off"
                               maxLength={155}
                               className="form-control" id="eventBookNotifyEmail"
                               placeholder="Booking Notification Email"/>
                    </div>
                  </Col>
                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">
                      <MDInput type="text"
                               InputLabelProps={{shrink: true}}
                               label={"Event Cancellation Notification"}
                               {...register('eventCancelNotifyEmail')}
                               autoComplete="off"
                               maxLength={155}
                               name={'eventCancelNotifyEmail'}
                               className="form-control" id="eventCancelNotifyEmail"
                               placeholder="Cancellation Notification Email"/>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col className={'col'} xs={12}>
                    <p className={'py-2 fw-light'}>
                      Notify email or distribution group for event booking and cancellation notifications.
                    </p>
                  </Col>
                </Row>

                <Divider/>

                <Row className={'mt-4'}>
                  <Col className={'col'} sm={12} xs={12}>
                    <h5>Waivers & Contracts</h5>
                  </Col>
                </Row>

                <Row>
                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">
                      <label htmlFor="inventoryWaiver">Event Waiver</label>
                      {waivers && waivers.length > 0 && <NativeSelect
                        variant="outlined"
                        defaultValue={-1}
                        id={'inventoryWaiver'}
                        name={'inventoryWaiver'}
                        className={'form-control'}
                        {...register('waiverGk', {
                          valueAsNumber: true,
                        })}>
                        <option value={-1}>Select Waiver</option>
                        {
                          waivers.map((c) =>
                            <option value={c.id} key={c.id}>
                              {c.waiverName}
                            </option>)
                        }
                      </NativeSelect>}
                    </div>
                  </Col>
                  <Col className={'col'} xs={12}>
                    <p className={'py-2 fw-light'}>
                      Add <b>additional waivers and contracts</b> for events that require them, such as drop-off care or
                      a
                      birthday party contract. These are separate from your general liability waiver and can be required
                      each time a customer participates.
                    </p>
                  </Col>
                </Row>

                <Row className={'mt-2'}>
                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">
                      <label htmlFor="eventFormGk">Intake Forms</label>
                      {forms && forms.length > 0 && <NativeSelect
                        variant="outlined"
                        defaultValue={-1}
                        id={'eventFormGk'}
                        name={'eventFormGk'}
                        className={'form-control'}
                        {...register('eventFormGk', {
                          valueAsNumber: true,
                        })}>
                        <option value={-1}>Select Form</option>
                        {
                          forms.map((c) =>
                            <option value={c.formGk} key={c.formGk}>
                              {c.formName}
                            </option>)
                        }
                      </NativeSelect>}
                    </div>
                  </Col>


                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">
                      <label htmlFor="inventoryWaiver">Guest Waiver</label>
                      {waivers && waivers.length > 0 && <NativeSelect
                        variant="outlined"
                        defaultValue={-1}
                        id={'guestWaiver'}
                        name={'guestWaiver'}
                        className={'form-control'}
                        {...register('guestWaiverGk', {
                          valueAsNumber: true,
                        })}>
                        <option value={-1}>Select Waiver</option>
                        {
                          waivers.map((c) =>
                            <option value={c.id} key={c.id}>
                              {c.waiverName}
                            </option>)
                        }
                      </NativeSelect>}
                    </div>
                  </Col>
                  <Col className={'col'} xs={12}>
                    <p className={'py-2 fw-light'}>
                      Guest Waivers include terms for event guests (like birthday guests) and are shared via special
                      link or QR code when linked to an Event Type.
                    </p>
                  </Col>
                </Row>

                <Divider/>

                <Row className={'mt-4'}>
                  <Col className={'col'} sm={12} xs={12}>
                    <h5>Booking Permissions</h5>
                  </Col>
                </Row>

                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">
                      <label htmlFor="name">Member Only Event</label>
                      <Switch
                        name={'memberOnly'}
                        id={'memberOnly'}
                        checked={memberOnly}
                        style={{marginRight: '5px'}}
                        onChange={toggleMemberOnly}
                      />
                      <p className={'py-2 fw-light'}>
                        Member Only Events are exclusive to selected Memberships and not accessible to non-members or
                        drop in rates.
                      </p>
                    </div>
                  </Col>
                </Row>

                <Row className={'mt-2'}>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">
                      <label htmlFor="name">Private Event</label>
                      <Switch
                        name={'privateAccess'}
                        id={'privateAccess'}
                        checked={privateAccess}
                        style={{marginRight: '5px'}}
                        onChange={togglePrivateAccess}
                      />
                      <p className={'py-2 fw-light'}>
                        Private Events are not shown on the public calendar or available for public booking. They're
                        bookable via private link and visible to staff. Ideal for rentals by outside businesses serving
                        their own clients.
                      </p>
                    </div>
                  </Col>
                </Row>

                <Row className={'mt-2'}>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">
                      <label htmlFor="name">Disable Self-Cancellation</label>
                      <Switch
                        name={'selfCancelDisabled'}
                        id={'selfCancelDisabled'}
                        checked={selfCancelDisabled}
                        style={{marginRight: '5px'}}
                        onChange={toggleSelfCancel}
                      />
                      <p className={'py-2 fw-light'}>
                        When disabled, customers will not be able to self-cancel an event from the customer portal.
                      </p>
                    </div>
                  </Col>
                </Row>

                <Row className={'mt-2'}>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">
                      <label htmlFor="name">Party Event</label>
                      <Switch
                        name={'specialEvent'}
                        id={'specialEvent'}
                        checked={specialEvent}
                        style={{marginRight: '5px'}}
                        onChange={toggleSpecialEvent}
                      />
                      <p className={'py-2 fw-light'}>
                        Party Events can only be booked by 1 person (Party family). Use Party Events for Birthday
                        Parties or Private Events where a single customer is the host.
                      </p>
                    </div>
                  </Col>
                </Row>

                <Row className={'mt-2'}>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">
                      <label htmlFor="name">Disable Waitlist</label>
                      <Switch
                        name={'disableWaitlist'}
                        id={'disableWaitlist'}
                        checked={disableWaitlist}
                        style={{marginRight: '5px'}}
                        onChange={toggleDisableWaitlist}
                      />
                      <p className={'py-2 fw-light'}>
                        Waitlists are enabled by default. Disabling this will hide fully booked events from the public
                        calendar.
                      </p>
                    </div>
                  </Col>
                </Row>


                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">
                      <label htmlFor="name">Hide Attendees</label>
                      <Switch
                        name={'hideAttendees'}
                        id={'hideAttendees'}
                        checked={hideAttendees}
                        style={{marginRight: '5px'}}
                        onChange={toggleHideAttendees}
                      />
                      <p className={'py-2 fw-light'}>
                        Choosing Hide Attendees will disable the "space available" item on the public portal.
                      </p>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">
                      <label htmlFor="name">Hide End Time</label>
                      <Switch
                        name={'hideEndTime'}
                        id={'hideEndTime'}
                        checked={hideEndTime}
                        style={{marginRight: '5px'}}
                        onChange={toggleHideEndTime}
                      />
                      <p className={'py-2 fw-light'}>
                        Choosing Hide End Time will disable the "end time" and "event duration" on the public portal.
                      </p>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">
                      <label htmlFor="name">Informational</label>
                      <Switch
                        name={'eventTypeInformational'}
                        id={'eventTypeInformational'}
                        checked={eventTypeInformational}
                        style={{marginRight: '5px'}}
                        onChange={toggleEventTypeInformational}
                      />
                      <p className={'py-2 fw-light'}>
                        Informational events will only display information to end user with no booking options or booked
                        full verbiage.
                      </p>
                    </div>
                  </Col>
                </Row>

                <Divider/>

                <Row className={'mt-4'}>
                  <Col className={'col'} sm={12} xs={12}>
                    <h5>Participant Settings</h5>
                  </Col>
                </Row>

                <Row>
                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">
                      <label htmlFor="ongoingBooking">Ongoing Booking</label>
                      <Switch
                        {...register('ongoingBooking')}
                        name={'ongoingBooking'}
                        id={'ongoingBooking'}
                        checked={ongoingBooking}
                        style={{marginRight: '5px'}}
                        onChange={toggleOngoingBooking}
                      />
                      <p className={'py-2 fw-light'}>
                        Guests can book even after the event has started.
                      </p>
                    </div>
                  </Col>

                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">
                      <label htmlFor="restrictedBooking">Pre-Event Only Booking</label>
                      <Switch
                        {...register('restrictedBooking')}
                        name={'restrictedBooking'}
                        id={'restrictedBooking'}
                        checked={restrictedBooking}
                        style={{marginRight: '5px'}}
                        onChange={toggleRestrictedBooking}
                      />
                      <p className={'py-2 fw-light'}>
                        Guests must book at the defined interval before the event.
                      </p>
                      {restrictedBooking && <MDInput type="number" step={1}
                                                     disabled={!restrictedBooking || ongoingBooking}
                                                     {...register('restrictedBookingValue', {
                                                       valueAsNumber: true,
                                                       required: restrictedBooking
                                                     })}
                                                     InputProps={{
                                                       startAdornment: <InputAdornment position="start">
                                                         <span className={'fa fa-clock'}></span>
                                                       </InputAdornment>,
                                                       endAdornment: <InputAdornment position="end">
                                                         <NativeSelect
                                                           sx={{
                                                             width: '160px',
                                                             position: 'relative',
                                                             right: '-14px'
                                                           }}
                                                           variant="outlined"
                                                           disabled={!restrictedBooking}
                                                           id={'restrictedBookingType'}
                                                           name={'restrictedBookingType'}
                                                           defaultValue={-1}
                                                           className={'form-control'}
                                                           {...register('restrictedBookingType', {
                                                             valueAsNumber: true,
                                                             min: 1,
                                                             required: restrictedBooking
                                                           })}>
                                                           <option value={-1}>Time</option>
                                                           {
                                                             timeUnitTypes.map((c) =>
                                                               <option value={c.id} key={c.id}>
                                                                 {c.name}
                                                               </option>)
                                                           }
                                                         </NativeSelect>
                                                       </InputAdornment>
                                                     }}
                                                     InputLabelProps={{shrink: true}}
                                                     label="Restrict Booking"
                                                     placeholder="Enter restriction value"
                                                     className="form-control"
                                                     autoComplete="off"
                                                     id="restrictedBookingValue"/>}
                    </div>
                  </Col>

                </Row>

                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">
                      <label htmlFor="name">Require Attendees</label>
                      <Switch
                        name={'requireAttendees'}
                        id={'requireAttendees'}
                        checked={requireAttendees}
                        style={{marginRight: '5px'}}
                        onChange={toggleRequireAttendees}
                      />
                      <p className={'py-2 fw-light'}>
                        Require Attendees prompts customers to select participants when booking a class or event.
                      </p>
                    </div>
                  </Col>
                </Row>

                <Row className={'mt-4'}>
                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">
                      <label className={'cursor-pointer'}
                             htmlFor={'infantOptionsToggle'}>Free Infant Rate
                      </label>
                      <Switch
                        name={'infantOptionsToggle'}
                        id={'infantOptionsToggle'}
                        style={{marginRight: '5px'}}
                        value={'infantOptionsToggle'}
                        disabled={familyPass}
                        checked={infantOptionsEnabled}
                        onChange={(e) => {
                          handleInfantOptionsToggle(e);
                        }}
                      />

                    </div>
                  </Col>
                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">
                      <MDInput type="float"
                               required={infantOptionsEnabled}
                               min={infantOptionsEnabled ? 1 : 0}
                               disabled={!infantOptionsEnabled || familyPass}
                               {...register('infantDiscountAge', {
                                 valueAsNumber: true
                               })}
                               InputProps={{
                                 startAdornment: <InputAdornment position="start">
                                   <span className={'fa fa-child'}></span>
                                 </InputAdornment>
                               }}
                               InputLabelProps={{shrink: true}}
                               label="Qualifying Infant Age"
                               placeholder="Enter qualifying infant age in months"
                               className="form-control"
                               autoComplete="off"
                               id="siblingDiscount"/>
                    </div>
                  </Col>
                  <Col className={'col'} xs={12}>
                    <p className={'py-2 fw-light'}>
                      If you offer a free infant rate, infants (e.g., under 6 months) can be added as attendees at no
                      charge.
                    </p>
                  </Col>
                </Row>

                <Row className={'mt-2'}>
                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">
                      <label className={'cursor-pointer'}
                             htmlFor={'siblingOptionsToggle'}>Sibling Drop-In Discount
                      </label>
                      <Switch
                        name={'siblingOptionsToggle'}
                        id={'siblingOptionsToggle'}
                        style={{marginRight: '5px'}}
                        value={'siblingOptionsToggle'}
                        disabled={familyPass}
                        checked={siblingOptionsEnabled}
                        onChange={(e) => {
                          handleSiblingOptionsToggle(e);
                        }}
                      />

                    </div>
                  </Col>
                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">
                      <MDInput type="float"
                               required={siblingOptionsEnabled}
                               min={siblingOptionsEnabled ? 1 : 0}
                               disabled={!siblingOptionsEnabled || familyPass}
                               {...register('siblingDiscount', {
                                 valueAsNumber: true
                               })}
                               InputProps={{
                                 startAdornment: <InputAdornment position="start">
                                   <span className={'fa fa-dollar-sign'}></span>
                                 </InputAdornment>
                               }}
                               InputLabelProps={{shrink: true}}
                               label="Sibling Drop-In Discount Amount"
                               placeholder="Enter Discount amount for siblings"
                               className="form-control"
                               autoComplete="off"
                               id="siblingDiscount"/>

                    </div>
                  </Col>
                </Row>
                <Row className={'mt-4'}>
                  <Col className={'col'} sm={12} xs={12}>
                    <p className={'fw-light'}>
                      Sibling Drop-In Discount applies when the first child pays full price, unlocking a reduced rate
                      for additional children. (Event cost will be added on the event creation)
                    </p>
                  </Col>
                </Row>

                <Row className={'mt-4'}>
                  <Col className={'col'} sm={12} xs={12}>
                    <h5>Deposits</h5>
                  </Col>
                </Row>

                <Row>
                  <Col className={'col'} md={6} sm={12}>
                    <div className="form-group">
                      <label htmlFor="name">Accept Deposit (Percentage)</label>
                      <Switch
                        name={'initialDeposit'}
                        id={'initialDeposit'}
                        disabled={memberOnly}
                        checked={initialDeposit}
                        style={{marginRight: '5px'}}
                        onChange={toggleDeposit}
                      />
                    </div>
                  </Col>

                  <Col className={'col'} md={6} sm={12}>

                    <div className="form-group">
                      <div className={'input-group'}>
                        <MDInput type="number" step="1" required={inventoryEventType?.initialDeposit}
                                 {...register('depositPercent', {
                                   valueAsNumber: true,
                                   max: 100,
                                   min: 0
                                 })}
                                 style={{
                                   borderTopRightRadius: '0px !important',
                                   borderBottomRightRadius: '0',
                                   borderRight: '0',
                                 }}
                                 disabled={!inventoryEventType?.initialDeposit}
                                 defaultValue={'0'}
                                 step={5}
                                 min={0}
                                 max={100}
                                 autoComplete="off"
                                 InputProps={{
                                   endAdornment: <InputAdornment position="end">
                                     <span className={'fa fa-percent'}></span>
                                   </InputAdornment>
                                 }}
                                 className="form-control" id="initialDeposit"
                                 label="Deposit Percent"/>

                      </div>
                    </div>
                  </Col>
                  <Col className={'col'} xs={12}>
                    <p className={'py-2 fw-light'}>
                      Initial Deposit is the percentage of the item's cost due at booking (e.g., 50% upfront, with the
                      remainder due later). A credit card on file is required.
                    </p>
                  </Col>
                </Row>

                <Row>
                  <Col className={'col'} md={6} sm={12}>
                    <div className="form-group">
                      <label htmlFor="name">Accept Deposit (Flat Amount)</label>
                      <Switch
                        name={'initialDepositFee'}
                        id={'initialDepositFee'}
                        disabled={memberOnly}
                        checked={initialDepositFee}
                        style={{marginRight: '5px'}}
                        onChange={toggleDepositFee}
                      />
                    </div>
                  </Col>

                  <Col className={'col'} md={6} sm={12}>

                    <div className="form-group">
                      <div className={'input-group'}>
                        <MDInput type="text" required={inventoryEventType?.initialDepositFee}
                                 {...register('depositAmount', {
                                   valueAsDouble: true,
                                 })}
                                 style={{
                                   borderTopRightRadius: '0px !important',
                                   borderBottomRightRadius: '0',
                                   borderRight: '0',
                                 }}
                                 disabled={!inventoryEventType?.initialDepositFee}
                                 defaultValue={'0'}
                                 step={0.01}
                                 min={0}
                                 autoComplete="off"
                                 InputProps={{
                                   startAdornment: <span className={'fa fa-dollar-sign'}></span>
                                 }}
                                 className="form-control" id="initialDepositFee"
                                 label="Deposit Amount"/>

                      </div>
                    </div>
                  </Col>
                  <Col className={'col'} xs={12}>
                    <p className={'py-2 fw-light'}>
                      Initial Deposit Amount is deposit amount required at booking. If the deposit amount exceeds the
                      cost of the event, the deposit amount will be ignored.
                    </p>
                  </Col>
                </Row>

                <Divider/>

                <Row className={'mt-4'}>
                  <Col className={'col'} sm={12} xs={12}>
                    <h5>Add-Ons &amp; Upgrades</h5>
                  </Col>
                </Row>

                <Row className={'mt-4'}>
                  <Col className={'col'} sm={12} xs={12}>
                    <h6>Event Packages</h6>
                  </Col>
                </Row>

                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <p className={'py-2 fw-light'}>
                      Packages can be added for birthdays (e.g., Gold, Silver, Bronze party levels) To add packages,
                      first create inventory items and then set up the package in Company Customization.
                    </p>

                    {eventPackages?.length > 0 && <>
                      <table className={"table table-striped table-hover"}>
                        <thead>
                        <tr>
                          <td>Assigned</td>
                          <td>Name</td>
                        </tr>
                        </thead>
                        <tbody>
                        {eventPackages?.sort((a, b) => a.id - b.id).map((pack, idx) => {
                          return (
                            <tr key={idx}>
                              <td>
                                <label>
                                  <Checkbox checked={assignedEventPackage(pack)}
                                            onChange={(e) => {
                                              toggleEventPackage(pack, e.target.checked)
                                            }}
                                  />
                                </label>
                              </td>
                              <td>
                                {pack.inventory.name}
                              </td>

                            </tr>
                          )
                        })
                        }
                        </tbody>
                      </table>
                    </>}

                  </Col>
                </Row>

                <Row className={'mt-2'}>
                  <Col className={'col'} sm={12} xs={12}>
                    <h6>Event Upsells</h6>
                    <p className={'py-2 fw-light'}>
                      Upsells are optional add-on items that can be included with any event, such as socks, coffee, baby
                      teethers, or craft baskets. They're a great way to offer extras for classes or enhance party
                      packages.
                    </p>

                    <Row>

                      <Col className={'col'} sm={6} xs={12}>
                        <div className="form-group">
                          <h6>Find by Inventory Type</h6>
                          {inventoryCategories && <NativeSelect
                            variant="outlined"
                            id={'inventoryCategory'}
                            name={'inventoryCategory'}
                            className={'form-control'}
                            onChange={(e) => {
                              setInventoryCategory(e.target.value);
                            }}>
                            <option value={-1}>
                              Filter By Type
                            </option>
                            {
                              inventoryCategories.map((c) =>
                                <option value={c.id} key={c.id}>
                                  {c.name}
                                </option>)
                            }
                          </NativeSelect>}
                        </div>

                        <ul className={'list-group'}>
                          {inventories?.length > 0 && inventories?.sort((a, b) => b.id - a.id).map((inventory, index) => {
                            return (
                              <li index={index} key={index}
                                  className={'list-group-item'}>
                                <Avatar alt={inventory.name}
                                        className={'pull-left mr-2'}
                                        sx={{width: 32, height: 32}}>
                                  <img src={inventory.imageUrl}
                                       style={{width: '200%', height: 'auto'}}
                                       alt={inventory.name}/>
                                </Avatar> &nbsp;{inventory.name}
                                <IconButton aria-label="Add" className={'pull-right mt-n1'} onClick={() => {
                                  assignInventory(inventory);
                                }}>
                                  <Icon>add_circle</Icon>
                                </IconButton>
                              </li>
                            )
                          })
                          }
                        </ul>
                      </Col>

                      <Col className={'col'} sm={6} xs={12}>
                        <h6>Assigned Items</h6>
                        {inventoryEventType?.eventInventoryGroups?.length === 0 && <>
                          <p>No assigned items</p>
                        </>}
                        {inventoryEventType?.eventInventoryGroups?.map((group, index) => {
                          return (
                            <Chip
                              key={index}
                              className={'m-1'}
                              index={index}
                              avatar={<Avatar src={group?.inventory.imageThumbUrl || group?.inventory.imageUrl}/>}
                              label={group?.inventory.name}
                              // onClick={handleClick}
                              onDelete={() => {
                                handleRemoveItem(group)
                              }}
                              variant="outlined"
                              color="secondary"/>
                          )
                        })
                        }
                      </Col>
                    </Row>

                  </Col>
                </Row>

              </Container>
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <MDButton type="submit" color="info" disabled={formInvalid || props.saving}>
            {props.saving ? 'Saving...' : 'Save'}
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  )
    ;
}